module.exports = __webpack_public_path__ + "static/media/signup_screen.726b32c7.png";